import { PaymentTypeCodes, formatPaymentType } from '../constants';

// Keys are human-readable on purpose: the map is hand-typed into a Baserow
// text cell (`paymentTypeLabels`), where numeric PaymentTypeCodes would be opaque.
const paymentTypeLabelKeys = {
  [PaymentTypeCodes.DEPOSIT]: 'deposit',
  [PaymentTypeCodes.GUARANTEE]: 'guarantee',
  [PaymentTypeCodes.LATE]: 'late',
};

const isNonEmptyString = (value) => typeof value === 'string' && value.trim() !== '';

const getPaymentTypeLabel = (paymentCode, travelAgency) => {
  const defaultLabel = formatPaymentType(paymentCode);
  try {
    const paymentTypeLabels = travelAgency?.settings?.paymentTypeLabels;
    const key = paymentTypeLabelKeys[paymentCode];
    if (!key || !paymentTypeLabels || typeof paymentTypeLabels !== 'object') {
      return defaultLabel;
    }

    const override = paymentTypeLabels[key];
    return isNonEmptyString(override) ? override : defaultLabel;
  } catch {
    return defaultLabel;
  }
};

export default getPaymentTypeLabel;
